import axios from 'axios';
import * as Qs from 'qs';
import * as _ from 'lodash';

import { IErrorResponse } from './models/IErrorResponse';
import toasterService from './services/toaster.service';
import { PROJECT_SN_PREFIX } from './consts';

// 处理项目错误信息
// （项目下发单、变更单等，多个项目数据错误时，error.response.data.details 中 的 key 值为项目序号：“序号x.x”，将其拼接到该条错误信息前）
function patchProjectsError(value: string, key: string) {
    if (0 === key.indexOf(PROJECT_SN_PREFIX)) {
        value = `${key}：${value}`;
    }
    return value;
}

// 请求拦截器
axios.interceptors.request.use((config) => {
    // 序列化请求参数，使可传数组参数
    config.paramsSerializer = (params) => {
        // 将数组参数转换成”&“拼接的字符串（例如：ids=[1,2] 转换成 ids=1&ids=2）
        return Qs.stringify(params, {
            indices: false
        })
    };
    // 添加时间戳，防止缓存
    config.params = Object.assign({}, config.params, {
        _: new Date().getTime()
    })
    return config;
}, (error) => {
    return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    switch (error.response.status) {
        case 401: // unauthorized 未登录或身份已过期
            location.href = '/login';
            break;
        default:
            const errorResponse: IErrorResponse = error.response.data;
            let isMessageAndValueDuplicate = false; // message和value重复
            const contents = [];
            if (errorResponse.details) {
                _.forEach(errorResponse.details, (value, key) => {
                    value = _.uniq(value);
                    if (_.includes(value, errorResponse.message)) {
                        isMessageAndValueDuplicate = true;
                    }
                    const content = patchProjectsError(value.join('；'), key);
                    contents.push(content);
                });
            }
            toasterService.show({
                type: 'danger',
                title: isMessageAndValueDuplicate ? '数据不正确' : errorResponse.message,
                contents: contents
            });
            return Promise.reject(errorResponse);
    }
});
